import React, {lazy, Suspense} from 'react';

const LazyActivitiesViewComponent = lazy(() => import('./ActivitiesView'));

const ActivitiesView = (props: JSX.IntrinsicAttributes & { children?: React.ReactNode; }) => (
  <Suspense fallback={null}>
    <LazyActivitiesViewComponent {...props} />
  </Suspense>
);

export default ActivitiesView;
